import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
  Collapsible,
  Form,
  Box,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../Helpers";
import Pagination from "@mui/material/Pagination";

const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [logs, setLogs] = useState(null);
  const [sessionReviews, setSessionReviews] = useState(null);
  const [instructorReviews, setInstructorReviews] = useState(null);
  const [classes, setClasses] = useState(null);
  const [packages, setPackages] = useState(null);
  const [memberships, setMemberships] = useState(null);
  const [ts, setTs] = useState("");
  const [optionsInstructors, setOptionsInstructors] = useState([]);
  const [pageLogs, setPageLogs] = useState(1);
  const [pageClasses, setPageClasses] = useState(1);
  const [pagePackages, setpagePackageP] = useState(1);
  const [pageMemberships, setPageMemberships] = useState(1);
  const refBoolPageLogs = useRef(true);
  const refBoolPageClasses = useRef(true);
  const refBoolPagePackages = useRef(true);
  const refBoolPageMemberships = useRef(true);
  const [totalLogs, setTotalLogs] = useState("");
  const [totalClasses, setTotalClasses] = useState("");
  const [totalPackages, setTotalPackages] = useState("");
  const [totalMemberships, setTotalMemberships] = useState("");
  const handleChangePageLogs = (event, value) => {
    refBoolPageLogs.current = true;
    setPageLogs(value);
  };

  const handleChangePageClasses = (event, value) => {
    refBoolPageClasses.current = true;
    setPageClasses(value);
  };

  const handleChangePagePackages = (event, value) => {
    refBoolPagePackages.current = true;
    setPageClasses(value);
  };
  const handleChangePageMemberships = (event, value) => {
    refBoolPageMemberships.current = true;
    setPageMemberships(value);
  };

  const perPage = 10;
  useEffect(() => {
    fetchData();
  }, [ts]);

  useEffect(() => {
    fetchLogs();
  }, [pageLogs]);

  useEffect(() => {
    fetchClasses();
  }, [pageClasses]);

  useEffect(() => {
    fetchPackages();
  }, [pagePackages]);

  useEffect(() => {
    fetchMemberships();
  }, [pageMemberships]);

  async function fetchClasses() {
    let responseClasses = "";
    try {
      responseClasses = await axios.get(
        `/app/users/${id}/classes?per_page=${perPage}&page=${
          refBoolPageClasses.current ? pageClasses : 1
        }`
      );
      setClasses(
        responseClasses.data.data.data.map((item, index) => [
          item?.id,
          item?.name ? item?.name : "-",
          item?.session?.date ? item?.session?.date : "-",
          item?.session?.launch_time ? item?.session?.launch_time : "-",
          item?.session?.instructors && item?.session?.instructors.length
            ? item?.session?.instructors.map((item) => item.name).join(", ")
            : item?.session?.instructor
            ? item?.session?.instructor?.name
            : "-",
          <Badge tone={switchStatusColor(item.pivot.status)}>
            {capitalizeFirstLetter(item?.pivot?.status)}
          </Badge>,
          item?.pivot?.updated_at
            ? moment(item?.pivot?.updated_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        ])
      );
      setTotalClasses(responseClasses.data.data.total);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchPackages() {
    let responsePackages = "";
    try {
      responsePackages = await axios.get(
        `/app/users/${id}/packages?per_page=${perPage}&page=${
          refBoolPagePackages.current ? pagePackages : 1
        }`
      );
      setPackages(
        responsePackages.data.data.data.map((item, index) => [
          item?.name ? item?.name : "-",
          item?.pivot?.start_date ? item?.pivot?.start_date : "-",
          item?.pivot?.expiry_date ? item?.pivot?.expiry_date : "-",
          item?.pivot?.remaining_bookings !== null
            ? item?.pivot?.remaining_bookings
            : "-",
          <Badge tone={switchStatusColor(item.pivot.status)}>
            {capitalizeFirstLetter(item?.pivot?.status)}
          </Badge>,
          <Badge tone={item?.pivot?.is_valid ? "success" : "critical"}>
            {item?.pivot?.is_valid ? "Active" : "Inactive"}
          </Badge>,
          item?.pivot?.created_at
            ? moment(item?.pivot?.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        ])
      );
      setTotalPackages(responsePackages.data.data.total);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchMemberships() {
    let responseMemberships = "";
    try {
      responseMemberships = await axios.get(
        `/app/users/${id}/memberships?per_page=${perPage}&page=${
          refBoolPageMemberships.current ? pageMemberships : 1
        }`
      );
      setMemberships(
        responseMemberships.data.data.data.map((item, index) => [
          item?.id,
          item?.name ? item?.name : "-",
          item?.pivot?.start_date ? item?.pivot?.start_date : "-",
          item?.pivot?.expiry_date ? item?.pivot?.expiry_date : "-",
          <Badge tone={switchStatusColor(item.pivot.status)}>
            {capitalizeFirstLetter(item?.pivot?.status)}
          </Badge>,
          <Badge tone={item?.pivot?.is_valid ? "success" : "critical"}>
            {item?.pivot?.is_valid ? "Active" : "Inactive"}
          </Badge>,
          item?.pivot?.created_at
            ? moment(item?.pivot?.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        ])
      );
      setTotalMemberships(responseMemberships.data.data.total);
    } catch (error) {
      console.log(error);
    }
  }
  async function fetchLogs() {
    let responseLogs = "";
    try {
      responseLogs = await axios.get(
        `/app/users/${id}/logs?per_page=${perPage}&page=${
          refBoolPageLogs.current ? pageLogs : 1
        }`
      );
      console.log(responseLogs.data.data);
      setLogs(
        responseLogs.data.data.data.map((item, index) => [
          item?.event ? item?.event : "-",
          item?.properties && item.properties?.source
            ? item?.properties?.source
            : "-",
          item?.properties && item.properties?.amount !== null
            ? item?.properties?.amount
            : "-",
          item?.properties && item.properties?.payment_type
            ? capitalizeFirstLetter(item?.properties?.payment_type)
            : "-",
          item?.description ? item?.description : "-",
          item?.properties && item?.properties?.notes
            ? item?.properties?.notes
            : "-",
          item?.created_at
            ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        ])
      );
      console.log("total=", responseLogs.data.data.total);
      setTotalLogs(responseLogs.data.data.total);
    } catch (error) {
      console.log(error);
    }
  }
  const [stats, setStats] = useState("");
  async function fetchData() {
    let responseItem = "";

    let responseInstructors = "";
    let responseSessionReviews = "";
    let responseInstructorReviews = "";
    let responseStats = "";

    try {
      responseItem = await axios.get(`/app/users/${id}`);
      setResult(responseItem.data.data);
      setSelectedAccessType(String(responseItem.data.data.access_type));
    } catch (error) {
      console.log(error);
    }
    try {
      responseStats = await axios.get(`/app/users/${id}/stats`);
      setStats(responseStats.data.data);
    } catch (error) {
      console.log(error);
    }

    try {
      responseSessionReviews = await axios.get(
        `/app/users/${id}/class-reviews`
      );
      setSessionReviews(
        responseSessionReviews.data.data.data.map((item, index) => [
          item?.related_class ? item.related_class?.name : "-",
          item?.title ? item?.title : "-",
          item?.description ? item?.description : "-",
          // item?.created_at
          //   ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
          //   : "-",
        ])
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseInstructorReviews = await axios.get(
        `/app/users/${id}/instructor-reviews`
      );
      setInstructorReviews(
        responseInstructorReviews.data.data.data.map((item, index) => [
          item?.instructor ? item?.instructor?.name : "-",
          item?.title ? item?.title : "-",
          item?.description ? item?.description : "-",
          // item?.created_at
          //   ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
          //   : "-",
        ])
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseInstructors = await axios.get(`/instructors?per_page=1000`);
      setOptionsInstructors(
        responseInstructors.data.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  const [note, setNote] = useState("");
  const handleChangeNote = (newValue) => {
    setNote(newValue);
  };
  const [amount, setAmount] = useState("");
  const handleChangeAmount = (newValue) => {
    setAmount(newValue);
    setAmountError("");
  };
  const [amountError, setAmountError] = useState("");

  const [selectedMethod, setSelectedMethod] = useState("");
  const handleChangeMethod = (newValue) => {
    setSelectedMethod(newValue);
    setMethodError("");
  };
  const [methodError, setMethodError] = useState("");

  const [type, setType] = useState("");
  const handleChangeType = (newValue) => {
    setType(newValue);
    setTypeError("");
  };
  const [typeError, setTypeError] = useState("");

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  const [openSessionReviews, setOpenSessionReviews] = useState(false);
  const handleToggleSessionReviews = useCallback(
    () => setOpenSessionReviews((openSessionReviews) => !openSessionReviews),
    []
  );
  const [openClasses, setOpenClasses] = useState(false);
  const handleToggleClasses = useCallback(
    () => setOpenClasses((openClasses) => !openClasses),
    []
  );
  const [openPackages, setOpenPackages] = useState(false);
  const handleTogglePackages = useCallback(
    () => setOpenPackages((openPackages) => !openPackages),
    []
  );
  const [openMemberships, setOpenMemberships] = useState(false);
  const handleToggleMemberships = useCallback(
    () => setOpenMemberships((openMemberships) => !openMemberships),
    []
  );
  const [openInstructorReviews, setOpenInstructorReviews] = useState(false);
  const handleToggleInstructorReviews = useCallback(
    () =>
      setOpenInstructorReviews(
        (openInstructorReviews) => !openInstructorReviews
      ),
    []
  );
  const [instructor, setInstructor] = useState("");
  const handleSelectChangeInstructor = (newValue) => {
    setInstructor(newValue);
    axios
      .post(`/app/users/${id}/type`, {
        amount: amount,
        notes: note,
        type: type,
        method: selectedMethod,
      })
      .then((result) => {
        setToastContent("Amount has been added successfully");
        toggleActive();
        setIsSaving(false);
        setTs(+new Date());
      })
      .catch((err) => {
        // setAmountError("Amount limit has been exceeded");
        //  setIsSaving(false);
      });
  };
  const [selectedAccessType, setSelectedAccessType] = useState("");
  const handleChangeAccessType = (newValue) => {
    setSelectedAccessType(newValue);
  };
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/app/users/${id}`)
      .then((result) => {
        navigate("/admin/users");
      })
      .catch((err) => console.log(err));
  };
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  return result ? (
    <Page
      // narrowWidth
      backAction={{ onAction: () => navigate("/admin/users") }}
      title={`${result?.first_name ? result?.first_name : ""} ${
        result?.last_name ? result?.last_name : ""
      }`}
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              USER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br /> {result?.first_name ? result?.first_name : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br /> {result?.last_name ? result?.last_name : "-"}
              </Text>
              <Text>
                <b>Email</b>
                <br /> {result?.email ? result?.email : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Created at</b>
                <br />
                {result?.created_at
                  ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
              <Text>
                <b>Nationality</b>
                <br /> {result?.nationality ? result?.nationality : "-"}
              </Text>
              <Text>
                <b>Date of Birth</b>
                <br /> {result?.birthday ? result?.birthday : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group>
              <Text>
                <b>Phone Number</b>
                <br /> {result?.phone_number ? result?.phone_number : "-"}
              </Text>
              <Text>
                <b>Gender</b>
                <br /> {result?.gender ? result?.gender : "-"}
              </Text>
              <Text>
                <b>Type</b>
                <br /> {result?.access_type === "0" ? "Customer" : "Instructor"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group>
              <Text>
                <b>Shoe Size</b>
                <br /> {result?.shoe_size !== null ? result?.shoe_size : "-"}
              </Text>
              <Text></Text>
              <Text></Text>
            </FormLayout.Group>
            {/* <FormLayout.Group>
              <div className="rowDiv">
                <Text>
                  <b>Type</b>
                  <br />
                  <Select
                    options={[
                      { label: "Customer", value: "0" },
                      { label: "Instructor", value: "200" },
                    ]}
                    onChange={handleChangeAccessType}
                    value={selectedAccessType}
                    placeholder="Please select"
                  />
                </Text>

                <Select2
                  options={optionsInstructors}
                  onChange={handleSelectChangeInstructor}
                  value={instructor}
                  placeholder="Please select"
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "290px",
                      marginTop: "0.6rem",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "70px",
                      overflowY: "auto",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: "70px",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPosition="absolute"
                />
              </div>
              <Text></Text> <Text></Text>
            </FormLayout.Group> */}
            <Text variant="headingSm" as="h6">
              WALLET DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text>
                <b>Currency</b>
                <br />{" "}
                {result?.wallet && result?.wallet?.currency
                  ? result?.wallet?.currency
                  : "-"}
              </Text>
              <Text>
                <b>Balance</b>
                <br />{" "}
                {result?.wallet && result?.wallet?.balance
                  ? result?.wallet?.balance
                  : "-"}
              </Text>
              <Text></Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>

        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              WALLET
            </Text>
            <FormLayout.Group>
              <TextField
                label="Add Amount"
                value={amount}
                onChange={handleChangeAmount}
                type="number"
                error={amountError}
                prefix="+"
              />
              <Select
                label="Method"
                options={[
                  { label: "Cash", value: "cash" },
                  {
                    label: "Offline Credit Card",
                    value: "offline_card",
                  },
                  { label: "Credits", value: "credits " },
                ]}
                onChange={handleChangeMethod}
                value={selectedMethod}
                error={methodError}
                placeholder="Please select"
              />
              <Select
                label="Type"
                options={[
                  { label: "Top Up", value: "topup" },
                  // { label: "Credit Card", value: "credit_card " },
                  {
                    label: "Bookings",
                    value: "bookings",
                  },
                  { label: "Refund", value: "refund" },
                  { label: "Cancellation", value: "cancellation" },
                  { label: "Other", value: "other" },
                ]}
                onChange={handleChangeType}
                value={type}
                error={typeError}
                placeholder="Please select"
              />
            </FormLayout.Group>
            <TextField label="Note" value={note} onChange={handleChangeNote} />
            <Button variant="primary" onClick={handleSave} loading={isSaving}>
              Add
            </Button>
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              LOGS
            </Text>
            <Button
              onClick={handleToggle}
              ariaExpanded={open}
              ariaControls="basic-collapsible"
              fullWidth
            >
              {open ? "Hide Logs" : "Show Logs"}
            </Button>
            <Collapsible
              open={open}
              id="basic-collapsible"
              transition={{ duration: "200ms", timingFunction: "ease-in-out" }}
              expandOnPrint
            >
              {logs?.length ? (
                <FormLayout>
                  <DataTable
                    columnContentTypes={["text", "text", "text", "text"]}
                    headings={[
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Event
                      </Text>,
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Source
                      </Text>,
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Amount
                      </Text>,
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Payment Type
                      </Text>,
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Description
                      </Text>,
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Note
                      </Text>,
                      <Text variant="bodyMd" as="p" fontWeight="medium">
                        Created at
                      </Text>,
                    ]}
                    rows={logs}
                    verticalAlign="middle"
                    increasedTableDensity
                    // truncate
                    // footerContent={
                    //   pageObject.tableItems?.length &&
                    //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                    // }
                    hasZebraStripingOnData
                  />
                  {Math.ceil(totalLogs / perPage) >= 2 && (
                    <div
                      style={{
                        paddingTop: "10px",
                        textAlign: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      <Pagination
                        variant="outlined"
                        count={Math.ceil(totalLogs / perPage)}
                        page={pageLogs}
                        onChange={handleChangePageLogs}
                      />
                      {/* <Pagination
                              count={Math.ceil(pageObject.tableTotalPages / perPage)}
                              page={page}
                              onChange={handleChangePage}
                              size="large"
                            /> */}
                    </div>
                  )}
                </FormLayout>
              ) : logs !== null ? (
                <Text>No logs found for this user</Text>
              ) : null}
            </Collapsible>
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              CLASSES
            </Text>
            {/* <Button
              onClick={handleToggleClasses}
              ariaExpanded={openClasses}
              ariaControls="basic-collapsible"
              fullWidth
            >
              {openClasses ? "Hide Classes" : "Show Classes"}
            </Button>
            <Collapsible
              open={openClasses}
              id="basic-collapsible"
              transition={{ duration: "200ms", timingFunction: "ease-in-out" }}
              expandOnPrint
            > */}
            {classes?.length ? (
              <FormLayout>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      ID
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Class
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Session Date
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Session Start Time
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Session Instructor(s)
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Status
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Subscription Date
                    </Text>,
                  ]}
                  rows={classes}
                  verticalAlign="middle"
                  increasedTableDensity
                  // truncate
                  // footerContent={
                  //   pageObject.tableItems?.length &&
                  //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                  // }
                  hasZebraStripingOnData
                />
                {Math.ceil(totalClasses / perPage) >= 2 && (
                  <div
                    style={{
                      paddingTop: "10px",
                      textAlign: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <Pagination
                      variant="outlined"
                      count={Math.ceil(totalClasses / perPage)}
                      page={pageClasses}
                      onChange={handleChangePageClasses}
                    />
                    {/* <Pagination
                          count={Math.ceil(pageObject.tableTotalPages / perPage)}
                          page={page}
                          onChange={handleChangePage}
                          size="large"
                        /> */}
                  </div>
                )}
              </FormLayout>
            ) : classes !== null ? (
              <Text>No classes found for this user</Text>
            ) : null}
            {/* </Collapsible> */}
          </FormLayout>
        </Card>

        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              PACKAGES
            </Text>
            {/* <Button
              onClick={handleTogglePackages}
              ariaExpanded={openPackages}
              ariaControls="basic-collapsible"
              fullWidth
            >
              {openPackages ? "Hide Packages" : "Show Packages"}
            </Button>
            <Collapsible
              open={openPackages}
              id="basic-collapsible"
              transition={{ duration: "200ms", timingFunction: "ease-in-out" }}
              expandOnPrint
            > */}
            {packages?.length ? (
              <FormLayout>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      ID
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Package
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Start Date
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Expiry Date
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Remaining Bookings
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Status
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Active / Inactive
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Subscription Date
                    </Text>,
                  ]}
                  rows={packages}
                  verticalAlign="middle"
                  increasedTableDensity
                  // truncate
                  // footerContent={
                  //   pageObject.tableItems?.length &&
                  //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                  // }
                  hasZebraStripingOnData
                />
                {Math.ceil(totalPackages / perPage) >= 2 && (
                  <div
                    style={{
                      paddingTop: "10px",
                      textAlign: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <Pagination
                      variant="outlined"
                      count={Math.ceil(totalPackages / perPage)}
                      page={pagePackages}
                      onChange={handleChangePagePackages}
                    />
                    {/* <Pagination
                              count={Math.ceil(pageObject.tableTotalPages / perPage)}
                              page={page}
                              onChange={handleChangePage}
                              size="large"
                            /> */}
                  </div>
                )}
              </FormLayout>
            ) : packages !== null ? (
              <Text>No packages found for this user</Text>
            ) : null}
            {/* </Collapsible> */}
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              MEMBERSHIPS
            </Text>
            {/* <Button
              onClick={handleToggleMemberships}
              ariaExpanded={openMemberships}
              ariaControls="basic-collapsible"
              fullWidth
            >
              {openMemberships ? "Hide Memberships" : "Show Memberships"}
            </Button>
            <Collapsible
              open={openMemberships}
              id="basic-collapsible"
              transition={{ duration: "200ms", timingFunction: "ease-in-out" }}
              expandOnPrint
            > */}
            {memberships?.length ? (
              <FormLayout>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      ID
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Membership
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Start Date
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Expiry Date
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Status
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Active / Inactive
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Subscription Date
                    </Text>,
                  ]}
                  rows={memberships}
                  verticalAlign="middle"
                  increasedTableDensity
                  // truncate
                  // footerContent={
                  //   pageObject.tableItems?.length &&
                  //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                  // }
                  hasZebraStripingOnData
                />
                {Math.ceil(totalMemberships / perPage) >= 2 && (
                  <div
                    style={{
                      paddingTop: "10px",
                      textAlign: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <Pagination
                      variant="outlined"
                      count={Math.ceil(totalMemberships / perPage)}
                      page={pageMemberships}
                      onChange={handleChangePageMemberships}
                    />
                    {/* <Pagination
                              count={Math.ceil(pageObject.tableTotalPages / perPage)}
                              page={page}
                              onChange={handleChangePage}
                              size="large"
                            /> */}
                  </div>
                )}
              </FormLayout>
            ) : memberships !== null ? (
              <Text>No memberships found for this user</Text>
            ) : null}
            {/* </Collapsible> */}
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              CLASSES REVIEWS
            </Text>
            {/* <Button
              onClick={handleToggleSessionReviews}
              ariaExpanded={openSessionReviews}
              ariaControls="basic-collapsible"
              fullWidth
            >
              {openSessionReviews
                ? "Hide Classes Reviews"
                : "Show Classes Reviews"}
            </Button>
            <Collapsible
              open={openSessionReviews}
              id="basic-collapsible"
              transition={{ duration: "200ms", timingFunction: "ease-in-out" }}
              expandOnPrint
            > */}
            {sessionReviews?.length ? (
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Class
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Title
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Description
                  </Text>,
                  // <Text variant="bodyMd" as="p" fontWeight="medium">
                  //   Created at
                  // </Text>,
                ]}
                rows={sessionReviews}
                verticalAlign="middle"
                increasedTableDensity
                // truncate
                // footerContent={
                //   pageObject.tableItems?.length &&
                //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                // }
                hasZebraStripingOnData
              />
            ) : sessionReviews !== null ? (
              <Text>No classes reviews found for this user</Text>
            ) : null}
            {/* </Collapsible> */}
          </FormLayout>
        </Card>

        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              INSTRUCTORS REVIEWS
            </Text>
            {/* <Button
              onClick={handleToggleInstructorReviews}
              ariaExpanded={openInstructorReviews}
              ariaControls="basic-collapsible"
              fullWidth
            >
              {openInstructorReviews
                ? "Hide Instructors Reviews"
                : "Show Instructors Reviews"}
            </Button>
            <Collapsible
              open={openInstructorReviews}
              id="basic-collapsible"
              transition={{ duration: "200ms", timingFunction: "ease-in-out" }}
              expandOnPrint
            > */}
            {instructorReviews?.length ? (
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Instructor
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Title
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Description
                  </Text>,
                  // <Text variant="bodyMd" as="p" fontWeight="medium">
                  //   Created at
                  // </Text>,
                ]}
                rows={instructorReviews}
                verticalAlign="middle"
                increasedTableDensity
                // truncate
                // footerContent={
                //   pageObject.tableItems?.length &&
                //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                // }
                hasZebraStripingOnData
              />
            ) : instructorReviews !== null ? (
              <Text>No instructors reviews found for this user</Text>
            ) : null}
            {/* </Collapsible> */}
          </FormLayout>
        </Card>

        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              STATISTICS
            </Text>
            <FormLayout.Group condensed>
              <Card>
                <Text as="h2" variant="headingSm">
                  Visits this week:
                </Text>
                <Box paddingBlockStart="200">
                  <Text variant="heading2xl" as="h3">
                    {stats?.weekly_visits}
                  </Text>
                </Box>
              </Card>
              <Card>
                <Text as="h2" variant="headingSm">
                  Visits this month:
                </Text>
                <Box paddingBlockStart="200">
                  <Text variant="heading2xl" as="h3">
                    {stats?.monthly_visits}
                  </Text>
                </Box>
              </Card>
              <Card>
                <Text as="h2" variant="headingSm">
                  Visits this year:
                </Text>
                <Box paddingBlockStart="200">
                  <Text variant="heading2xl" as="h3">
                    {stats?.yearly_visits}
                  </Text>
                </Box>
              </Card>
              <Card>
                <Text as="h2" variant="headingSm">
                  Total Visits:
                </Text>
                <Box paddingBlockStart="200">
                  <Text variant="heading2xl" as="h3">
                    {stats?.total_visits}
                  </Text>
                </Box>
              </Card>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Card>
                <Text as="h2" variant="headingSm">
                  Member since:
                </Text>
                <Box paddingBlockStart="200">
                  <Text variant="heading2xl" as="h3">
                    {stats?.membership_duration}
                  </Text>
                </Box>
              </Card>
            </FormLayout.Group>
          </FormLayout>
        </Card>
      </FormLayout>
      <PageActions
        secondaryActions={
          <Button
            variant="primary"
            loading={isSaving}
            tone="critical"
            onClick={() => setActiveDelete(true)}
          >
            Delete
          </Button>
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this user?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function handleSave() {
    if (amount === "" || !type || !selectedMethod) {
      amount === "" && setAmountError("Please enter a value to add");
      !type && setTypeError("Please choose an option");
      !selectedMethod && setMethodError("This field is required");
    } else {
      setIsSaving(true);
      axios
        .post(`/app/users/${id}/wallet`, {
          amount: amount,
          notes: note,
          type: type,
          method: selectedMethod,
        })
        .then((result) => {
          setToastContent("Amount has been added successfully");
          toggleActive();
          setIsSaving(false);
          setTs(+new Date());
        })
        .catch((err) => {
          // setAmountError("Amount limit has been exceeded");
          //  setIsSaving(false);
        });
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default UserDetails;
